/**
 * Fallback user context for logPAPEvent so non-React call sites
 * (Redux thunks, direct logPAPEvent imports) get user identifiers
 * without threading context through every call site.
 */

export type PAPUserContext = {
  guid: string;
  dbxUserId?: string | null;
};

let currentUser: PAPUserContext | null = null;

export function setPAPUser(user: PAPUserContext | null): void {
  currentUser = user;
}

export function getPAPUser(): PAPUserContext | null {
  return currentUser;
}

export function clearPAPUser(): void {
  currentUser = null;
}
